import React, { useEffect, useState } from 'react';
import { useAppSelector } from 'store/store';
import { headerTaxoSelector } from 'store/selectors/taxonomySelector';
import { setDataEmTag } from 'utility/utility';
import { HomefieldIconListMenu } from '@dsg-tech/homefield-react-icons';
import { Button, TextLink } from '@dsg-tech/homefield-react';
import ErrorBoundaryWithLogger from 'common/ErrorBoundary/ErrorBoundary';
import { breakpointSelector } from 'store/selectors';
import { NEW_KEY_CODES } from 'utility/constants';
import MainLogo from 'common/MainLogo/MainLogo';
import Modal from '../../common/Modal/Modal';
import DropDownNavSM from './DropdownNavSM/DropdownNavSM';
import SlideinNavSM from './SlideinNavSM/SlideinNavSM';
import './HeaderSM.scss';

interface HeaderState {
  dropdownOpen: boolean;
}

const HeaderSM = () => {
  const { headerNavLinks } = useAppSelector(headerTaxoSelector);
  const [openDrawer, setOpenDrawer] = useState<HeaderState['dropdownOpen']>(false);
  const viewPortBreakpoint = useAppSelector(breakpointSelector);

  useEffect(() => {
    if (viewPortBreakpoint !== 'mobile') {
      setOpenDrawer(false);
    }
  }, [viewPortBreakpoint]);

  return (
    <div className="sm-header hmf-display-flex hmf-flex-column hmf-justify-content-center hmf-display-xs">
      <div className="nav-bar-container hmf-w-100">
        <div className="nav-bar hmf-m-auto hmf-m-0 hmf-w-100 hmf-display-flex hmf-justify-content-flex-end">
          <TextLink
            variant="primary"
            tabIndex={0}
            href="https://www.classy.org/give/389610/#!/donation/checkout"
            className="donate-button hmf-p-s hmf-px-m-m hmf-py-m-s hmf-subheader-l"
            data-em={setDataEmTag('Header', 'Donate')}>
            Donate
          </TextLink>
        </div>
      </div>
      <header className="rc-sm-header hmf-w-100 hmf-m-auto hmf-m-0">
        <div className="rc-subheader hmf-display-flex hmf-justify-content-between hmf-mx-auto hmf-position-relative">
          <MainLogo className="rc-sm-logo-link" />
          <DropDownNavSM headerNavLinks={headerNavLinks} />
          <span className="responsive-header-mobile-nav-open">
            <SlideinNavSM
              open={openDrawer}
              closeHandler={() => setOpenDrawer(false)}
              headerNavLinks={headerNavLinks}
            />
          </span>
          <div className="hmf-display-flex hmf-display-m-none hmf-justify-content-flex-end hmf-p-0">
            <Button
              variant="tertiary"
              onClick={() => setOpenDrawer(true)}
              onKeyDown={(event) => {
                if (event.key === NEW_KEY_CODES.SPACE || event.key === NEW_KEY_CODES.ENTER) {
                  setOpenDrawer(true);
                }
              }}
              icon={<HomefieldIconListMenu />}
              className="header-menu-hamburger-btn"
              label="Open Menu"
            />
          </div>
        </div>
      </header>
      <ErrorBoundaryWithLogger componentId="HeaderSM-Modal">
        <Modal />
      </ErrorBoundaryWithLogger>
    </div>
  );
};

export default HeaderSM;
